/**
 * Sources needed for widgets' script and link tags.
 */
export enum Source {
  JQUERY = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js',
  JQUERY_UI = 'https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js',
  JQUERY_CSS = 'https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/themes/smoothness/jquery-ui.css',
  DATEPICKER_CSS = '/leasing/css/datepicker.css',
}
